
import dayjs from 'dayjs'

export const createMonthArr = (month, year) => {
    const startOfMonth = dayjs(new Date(year, month, 1))
    const endOfMonth = startOfMonth.endOf('month')

    const start = startOfMonth.startOf('week')
    const end = endOfMonth.endOf('week')

    const arr = []
    let current = start

    while (current.isBefore(end) || current.isSame(end, 'day')) {
        arr.push(current)
        current = current.add(1, 'day')
    }

    return arr
}

export const createWeekArr = (day, month, year) => {
    const firstday = dayjs().set('date', day).set('month', month).set('year', year)
    let cursor = firstday.subtract(4, 'day')
    const lastDay = firstday.add(4, 'day')
    const dayArr = []
    while (cursor <= lastDay) {
        dayArr.push(cursor)
        cursor = cursor.add(1, 'day')
    }
    return dayArr
}

